/* eslint-disable no-await-in-loop */
import { sleep } from "./async.js";

export const jitter = ({ max, min }: { min: number; max: number }): number => {
  if (max > min) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  } else {
    return min;
  }
};

export interface RetryArgs<R> {
  func: (attempt: number) => Promise<R>;
  retryCount: number;
  interval: number | { min: number; max: number }; // in millis
  shouldRetry?: (err: unknown) => boolean;
  /** Stops retrying once it aborts, rejecting with its reason, including mid-wait. */
  signal?: AbortSignal;
}

export async function retry<R>({
  func,
  interval,
  retryCount,
  shouldRetry,
  signal,
}: RetryArgs<R>): Promise<R> {
  for (let i = 0; i <= retryCount; i++) {
    signal?.throwIfAborted();
    try {
      return await func(i + 1);
    } catch (err) {
      signal?.throwIfAborted();
      if (shouldRetry != null && !shouldRetry(err)) {
        throw err;
      }
      if (i < retryCount - 1) {
        await sleep(
          typeof interval === "number" ? interval : jitter(interval),
          {
            signal,
          },
        );
      } else {
        throw err;
      }
    }
  }

  throw new Error("Impossible to reach.");
}
